import React, { Component } from 'react'
import { reducer } from './utils'

import * as El from '../styles'

export default class TextInput extends Component {
  componentWillReceiveProps () {
    // focus the field if there is an error
    const { field, form: { touched, errors } } = this.props
    const error = reducer(errors, field.name)
    const touch = reducer(touched, field.name)
    if (error && touch) {
      document.getElementById(field.name).scrollIntoView()
    }
  }
  render () {
    const { field, form: { touched, errors }, ...props } = this.props
    const name = field.name
    const text = reducer(props.form_s, name)
    const error = reducer(errors, name)
    const touch = reducer(touched, name)
    const key = name.split('.').slice(-1)[0]
    return (
      <El.Input
        id={name}
        error={error && touch ? 'true' : null}
        type={key === 'postal_code' || key === 'tel' ? 'number' : 'text'}
        name={name}
        placeholder={text}
        onKeyDown={e => {
          if (
            (key === 'postal_code' || key === 'tel') &&
            ['e'].includes(e.key)
          ) {
            e.preventDefault()
          }
        }}
      />
    )
  }
}
